import { Box, Typography } from '@mui/material';
import { Column } from 'src/components/UI/DataTable';
import { AvailableNewCitationsRowData, ExistingCitationsTableRowData } from '../components/SelectCitations';
import {
  tableCellTypographySx,
  businessNameTypographySx
} from '../styles/createCampaign';
import { NotesIcons } from '../components/NotesIcons';

// Constants
const CITATION_SITE_LABEL = 'Citation Site';
const BUSINESS_ADDRESS_LABEL = 'Business Address';
const ZIP_LABEL = 'Zip';
const PHONE_NUMBER_LABEL = 'Phone Number';
const NOTES_LABEL = 'Notes';

// Column widths
const COLUMN_WIDTHS = {
  citationSite: 100,
  businessAddress: 300,
  zip: 100,
  phoneNumber: 100,
  notes: 100,
  checkbox: 80
} as const;

/**
 * Creates the table columns configuration for the citations table
 */
export const createCitationsColumns = (): Column<ExistingCitationsTableRowData>[] => [
  {
    id: 'citationSite',
    label: CITATION_SITE_LABEL,
    width: COLUMN_WIDTHS.citationSite,
    sortable: true
  },
  {
    id: 'businessAddress',
    label: BUSINESS_ADDRESS_LABEL,
    width: COLUMN_WIDTHS.businessAddress,
    render: (row) => (
      <>
        <Typography sx={businessNameTypographySx}>
          {row.businessName}
        </Typography>
        <Typography sx={tableCellTypographySx}>{row.address}</Typography>
      </>
    )
  },
  {
    id: 'zip',
    label: ZIP_LABEL,
    width: COLUMN_WIDTHS.zip
  },
  {
    id: 'phoneNumber',
    label: PHONE_NUMBER_LABEL,
    width: COLUMN_WIDTHS.phoneNumber
  },
  {
    id: 'notes',
    label: NOTES_LABEL,
    width: COLUMN_WIDTHS.notes,
    render: (row) => <NotesIcons notes={row.notes} />
  },
  {
    id: 'checkbox',
    type: 'checkbox',
    width: COLUMN_WIDTHS.checkbox
  }
];

// Constants for Available New Citations
const TYPE_OF_SITE_LABEL = 'Type of Site';
const AUTHORITY_LABEL = 'Authority';
const VALUE_LABEL = 'Value';

// Column widths for Available New Citations
const AVAILABLE_NEW_COLUMN_WIDTHS = {
  citationSite: 150,
  typeOfSite: 150,
  authority: 100,
  value: 100,
  notes: 100,
  checkbox: 80
} as const;

/**
 * Creates the table columns configuration for the Available New Citations table
 */
export const createAvailableNewCitationsColumns = (): Column<AvailableNewCitationsRowData>[] => [
  {
    id: 'citationSite',
    label: CITATION_SITE_LABEL,
    width: AVAILABLE_NEW_COLUMN_WIDTHS.citationSite,
    sortable: true
  },
  {
    id: 'typeOfSite',
    label: TYPE_OF_SITE_LABEL,
    width: AVAILABLE_NEW_COLUMN_WIDTHS.typeOfSite,
    sortable: true
  },
  {
    id: 'authority',
    label: AUTHORITY_LABEL,
    width: AVAILABLE_NEW_COLUMN_WIDTHS.authority,
    sortable: true,
    sortValue: (row) => row.authority
  },
  {
    id: 'value',
    label: VALUE_LABEL,
    width: AVAILABLE_NEW_COLUMN_WIDTHS.value,
    sortable: true
  },
  {
    id: 'notes',
    label: NOTES_LABEL,
    width: AVAILABLE_NEW_COLUMN_WIDTHS.notes,
    render: (row) => <NotesIcons notes={row.notes} />
  },
  {
    id: 'checkbox',
    type: 'checkbox',
    width: AVAILABLE_NEW_COLUMN_WIDTHS.checkbox
  }
];

